import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9 6.762v8.25m6-6v8.25m.503 3.498 4.875-2.437c.381-.191.622-.58.622-1.007V4.832c0-.836-.88-1.38-1.628-1.006L15.503 5.76c-.317.158-.69.158-1.006 0L9.503 3.263a1.13 1.13 0 0 0-1.006 0L3.622 5.701A1.12 1.12 0 0 0 3 6.707V19.19c0 .837.88 1.38 1.628 1.007l3.869-1.935c.317-.158.69-.158 1.006 0l4.994 2.497c.317.158.69.158 1.006 0"
    }, null, -1)
  ])))
}
export default { render: render }